import { useEffect } from 'react';

import { useCRMEventsContext } from '@fhs/auth/src/hooks';
import { useRewardTierApplied } from '@fhs/loyalty/src/hooks/use-reward-tier-applied';
import { isPointsCartOffer } from '@fhs/loyalty/src/utils/points-offers';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';

import { logCheckoutDiscountNotApplied } from '../../../utils/logging-utils';
import SavingsWithOffer from '../../savings-with-offer';

export function CartSavingsBanner({ savings }: { savings: number }) {
  const { logRBIEvent } = useCRMEventsContext();
  const selectedOffer = useAppSelector(selectors.loyalty.selectSelectedOffer);
  const { rewardTierApplied } = useRewardTierApplied();

  const hasIncentiveApplied = !!selectedOffer || !!rewardTierApplied;
  const appliedIncentiveId = selectedOffer?._id ?? rewardTierApplied?.id;
  const shouldLogDiscountNotApplied =
    hasIncentiveApplied && savings === 0 && !isPointsCartOffer(selectedOffer);

  useEffect(() => {
    if (shouldLogDiscountNotApplied) {
      logCheckoutDiscountNotApplied(logRBIEvent);
    }
  }, [shouldLogDiscountNotApplied, appliedIncentiveId, logRBIEvent]);

  if (!hasIncentiveApplied || savings === 0) {
    return null;
  }

  return <SavingsWithOffer savings={savings} />;
}
